import { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

/**
 * Global platform admin: User.role === 'admin' (verified via GET /api/user/account).
 */
export function usePlatformAdmin() {
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchRole = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsPlatformAdmin(false);
      setLoading(false);
      return;
    }
    try {
      const res = await api.get('/api/user/account');
      setIsPlatformAdmin(res.data?.role === 'admin');
    } catch {
      setIsPlatformAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRole();
  }, [fetchRole]);

  useEffect(() => {
    const onFocus = () => {
      if (localStorage.getItem('token')) fetchRole();
    };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [fetchRole]);

  return { isPlatformAdmin, loading };
}

export default usePlatformAdmin;
